import Vue from 'vue'
import Vuex from 'vuex'

import jwtParser from "./mixins/jwtParser.js"
import {api} from './mixins/api.js'
import router from './router'
import {getField, updateField} from 'vuex-map-fields'

Vue.use(Vuex);

const REFRESHTOKEN_LS = "refreshToken"
const ACCESSTOKEN_LS = "accessToken"

// eslint-disable-next-line no-unused-vars
export default new Vuex.Store({
  state: {
    refreshToken: '',
    accessToken: '',
    refreshTokenInfo: {
      exp: '',
    },
    accessTokenInfo: {
      exp: '',
    },
    authorityLevel: 0,
    profile: null,
    menuVisible: false,
    menuData: require('../data/menu.json'),
    mobileMenu: false,
    drawer: false,
    realestateD3Root: null,
    economyD3Root: null,
    paymentRequiredDialog: false,
    showRichgoMobileBanner: true,
    // 로그인 여부 캐싱용 (refreshToken이 셋팅되거나 isLoggedin을 호출하면 업데이트된다.)
    isLoggedin: false,
    selectedTableauId: null,
    showHyundaiLoginFailedPopup: false,
    showDlconLoginFailedPopup: false,
    bjdInfo: {}, // 법정동 필터로 태블로 임배딩 액션 주입
    priceType: "richgo",
    showMap: false,
    kakaoAddressInfo: {},
    businessSiteInputInfo: {}
  },
  mutations: {
    updateField,
    setRefreshTokenCommon(state, token) {
      if (!token)
        return;
      state.refreshToken = token;
      const jwt = jwtParser.parseJwt(token);
      state.refreshTokenInfo.exp = jwt.exp;
      state.isLoggedin = (state.refreshToken !== '' && jwtParser.isExpired(state.refreshTokenInfo.exp) === false);
      state.profile = {
        'userId': jwt.nameid,
        'isHyundai' : state.isLoggedin && jwt.ExternalProviderName === "hdec",
        'isDlcon' : state.isLoggedin && jwt.ExternalProviderName === "dlcon",
        'isCorp': state.isLoggedin && (jwt.ExternalProviderName === "hdec" || jwt.ExternalProviderName === "dlcon")
      };
    },
    setRefreshToken(state, token) {
      this.commit('setRefreshTokenCommon', token);
      this.commit('setRefreshTokenStorage', token);
    },
    setRefreshTokenStorage(state, token) {
      localStorage.setItem(REFRESHTOKEN_LS, token);
    },
    setRefreshTokenWithoutStorageUpdate(state, token) {
      this.commit('setRefreshTokenCommon', token);
    },
    setAccessTokenCommon(state, token) {
      state.accessToken = token;
      const jwt = jwtParser.parseJwt(token);
      state.accessTokenInfo.exp = jwt.exp;
      state.authorityLevel = parseInt(jwt.AuthorityLevel) || 0;
    },
    setAccessToken(state, token) {
      this.commit('setAccessTokenCommon', token);
      this.commit('setAccessTokenStorage', token);
    },
    setAccessTokenStorage(state, token) {
      localStorage.setItem(ACCESSTOKEN_LS, token);
    },
    setAccessTokenWithoutStorageUpdate(state, token) {
      this.commit('setAccessTokenCommon', token);
    },
    showDrawer(state, v) {
      state.drawer = v;
    },
    showMenu(state, v) {
      state.menuVisible = v;
    },
    showMobileMenu(state, v) {
      state.mobileMenu = v;
    },
    showPaymentRequiredDialog(state, v) {
      state.paymentRequiredDialog = v;
    },
    showRichgoMobileBanner(state, v) {
      state.showRichgoMobileBanner = v;
    },
    logout(state, isLocalStorageUpdate) {
      state.refreshToken = '';
      state.refreshTokenInfo.exp = '';
      state.accessToken = '';
      state.accessTokenInfo.exp = '';
      state.isLoggedin = false;
      // ie11 은 default parameter가 안 먹는다.
      console.log('logout', isLocalStorageUpdate);
      isLocalStorageUpdate = typeof isLocalStorageUpdate !== 'undefined' ? isLocalStorageUpdate : true;

      if (isLocalStorageUpdate) {
        console.log('isLocalStorageUpdate', isLocalStorageUpdate)
        localStorage.removeItem(REFRESHTOKEN_LS);
        localStorage.removeItem(ACCESSTOKEN_LS);
      }
    },
    setRealestateD3Root(state, v) {
      state.realestateD3Root = v;
    },
    setEconomyD3Root(state, v) {
      state.economyD3Root = v;
    },
    setSelectedTableauId(state, v) {
      state.selectedTableauId = v;
    },
    setShowHyundaiLoginFailedPopup(state, v) {
      state.showHyundaiLoginFailedPopup = v;
    },
    setShowDlconLoginFailedPopup(state, v) {
      state.showDlconLoginFailedPopup = v;
    },
    setBjdInfo(state, v) {
      state.bjdInfo = {
        'sd': v.sd,
        'sgg': v.sgg,
        'emd': v.emd,
        'bjdCode': v.bjdCode
      };
      localStorage.setItem("BJD_INFO_LS", JSON.stringify(state.bjdInfo));
    },
    setPriceType(state, v) {
      state.priceType = v;
      localStorage.setItem("PRICE_TYPE_LS", v);
    },
    setShowMap(state, v) {
      state.showMap = v;
    },
    setKakaoAddressInfo(state, v) {
      state.kakaoAddressInfo = v;
    },
    updateKakaoAddressBjdInfo(state, v) {
      state.kakaoAddressInfo = {
        ...state.kakaoAddressInfo,
        "bjdCode": v
      };
    },
    setBusinessSiteInputInfo(state, v) {
      state.businessSiteInputInfo = v;
    }
  },
  getters: {
    getField
  },
  actions: {
    updateLoggedin ({state}) {
      const value = (state.refreshToken !== '' && jwtParser.isExpired(state.refreshTokenInfo.exp) === false);
      state.isLoggedin = value;
      return value;
    },
    refreshTokenExpired ({state}) {
      if (state.refreshToken !== '') {
        return jwtParser.isExpired(state.refreshTokenInfo.exp);
      }
      return true;
    },
    accessTokenExpired ({state}) {
      if (state.accessToken !== '') {
        return jwtParser.isExpired(state.accessTokenInfo.exp);
      }
      return true;
    },
    async ensureAccessToken ({dispatch, commit, state}) {
      console.log('ensureAccessToken')
      if (await dispatch('updateLoggedin') === false) {
        // todo 내가만약 현대라면 여기에 안 가고 건설사의 로그인 페이지에 가게 해야한다.


          alert('로그인이 필요합니다.')
          router.push('/login')
          return;
      }

      if (state.accessToken !== '' && await dispatch('accessTokenExpired') === false) {
          console.log('아직 AccessToken 만료가 되지 않았습니다.');
          // do nothing
      } else {
        const accessToken = await api.methods.getAccessToken();
        if (accessToken) {
          if (accessToken === 409) {
            router.push('/duplicated-loggedin');
            return;
          }
          console.log('새로 발급된 AccessToken', accessToken);
          commit('setAccessToken', accessToken);
        }
      }
    },
    async forceUpdateAccessToken({commit}) {
      const accessToken = await api.methods.getAccessToken();
      if (accessToken) {
        if (accessToken === 409) {
          router.push('/duplicated-loggedin');
          return;
        }
        console.log('새로 발급된 AccessToken', accessToken);
        commit('setAccessToken', accessToken);
      }
    }
  }
})
